import config from "../../../config";
import Heading from "../../atoms/Heading";
import { ExperienceCard } from "../../molecules/ExperienceCard";
import { SectionDetails } from "../../molecules/SectionDetails";

function Experience() {
  return (
    <SectionDetails
      column
      heading={<Heading>Experience</Heading>}
      details={config.experiences.map((experience, index) => (
        <ExperienceCard
          key={index}
          company={experience.company}
          position={experience.position}
          startDate={experience.startDate}
          endDate={experience.endDate}
          isCurrent={experience.isCurrent}
        />
      ))}
    />
  );
}

export default Experience;
